var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"redeem-btn",class:_vm.strButtonClass,on:{"click":function($event){return _vm.clickRedeem()}}},[_c('img',{attrs:{"src":require("@/assets/megaWish/btn-luckydraw@2x.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }